import React from 'react';

type Tone = 'default' | 'ok' | 'warn' | 'err' | 'info' | 'navy' | 'cyan';

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
  dot?: boolean;
};

const toneClass: Record<Tone, string> = {
  default: '',
  ok: 'badge-ok',
  warn: 'badge-warn',
  err: 'badge-err',
  info: 'badge-info',
  navy: 'badge-navy',
  cyan: 'badge-cyan',
};

export const Badge: React.FC<BadgeProps> = ({
  tone = 'default',
  dot,
  className = '',
  ...rest
}) => {
  const cls = ['badge', toneClass[tone], dot ? 'badge-dot' : '', className]
    .filter(Boolean)
    .join(' ');
  return <span className={cls} {...rest} />;
};
